import type { InvoiceRow } from "@/types/api";

/** Matches Amount column: Stripe minor units; null/undefined treated as zero. */
export function isZeroAmountInvoice(row: Pick<InvoiceRow, "amount_due">): boolean {
  return (row.amount_due ?? 0) === 0;
}

/** Receipts page: paid rows with $0 have no Stripe payment receipt. */
export function isReceiptRowSelectable(row: InvoiceRow): boolean {
  return row.exportable !== false && !isZeroAmountInvoice(row);
}
